import React from 'react';
import { Route, Switch } from 'react-router-dom';
import useReactRouter from 'use-react-router';

import Authorize from '../layout/Authorize';
import Processing from './Processing';

export default (() => {

  const { match } = useReactRouter();

  return (
    <Authorize>
      <Switch>
        <Route path={`${match.url}/processing`} component={Processing} />
      </Switch>
    </Authorize>
  )
}) as React.FC;
